export default __webpack_public_path__ + "static/media/keyvisual-schwaebisch-hall-crailsheim.3335d5f9.jpg";